import React from 'react';

const PageNotFound = () =>
    <div id="not_found" className="main_content">
        Page Not Found
    </div>;

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/components/page_not_found/PageNotFound.jsx